<div class="service-details-page premium-theme" *ngIf="service">

    <!-- Sticky Breadcrumbs -->
    <nav class="breadcrumb-nav">
        <a routerLink="/wedding-services">Home</a>
        <span class="material-symbols-outlined">chevron_right</span>
        <a routerLink="/wedding-services/list">{{service.category?.name}}</a>
        <span class="material-symbols-outlined">chevron_right</span>
        <!-- <a routerLink="/wedding-services/merchant/:id">{{merchant.business_name}}</a>
        <span class="material-symbols-outlined">chevron_right</span> -->
        <span class="current">{{service.service_name}}</span>
    </nav>



    <!-- Main Content Area -->
    <div class="layout-container">
        
        <div class="left-column">
            
            <!-- Service Header -->
            <section class="service-header">
                <div class="title-row">
                    <h1>{{service.service_name}}</h1>
                    <div class="actions mobile-only">
                        <button class="icon-btn"><span class="material-symbols-outlined">favorite_border</span></button>
                        <button class="icon-btn"><span class="material-symbols-outlined">share</span></button>
                    </div>
                </div>
                
                <div class="vendor-meta">
                    <div class="vendor-info">
                        <span class="vendor-name">{{mockVendor.name}}</span>
                        <div class="badges">
                            <span class="badge premium" *ngIf="mockVendor.isPremium"><span class="material-symbols-outlined">workspace_premium</span> Premium</span>
                            <span class="badge verified" *ngIf="mockVendor.isVerified"><span class="material-symbols-outlined">verified</span> Verified</span>
                        </div>
                    </div>
                    
                    <div class="stats-row">
                        <div class="stat rating">
                            <span class="material-symbols-outlined icon-star">star</span>
                            <strong>{{mockVendor.rating}}</strong>
                            <span class="text-muted">({{mockVendor.reviewCount}} reviews)</span>
                        </div>
                        <span class="divider">•</span>
                        <div class="stat bookings">
                            <span class="material-symbols-outlined">check_circle</span>
                            <span>{{mockVendor.bookingCount}} Bookings</span>
                        </div>
                        <span class="divider">•</span>
                        <div class="stat location">
                            <span class="material-symbols-outlined">location_on</span>
                            <span>{{service.service_locations?.[0] || 'Multiple Locations'}}</span>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Sponsored Advertisement Banner -->
            <section class="sponsored-ad-banner" *ngIf="service.merchantId?.subscriptionTier === 'PREMIUM' && service.merchantId?.advertisement?.isActive">
                <div class="ad-content">
                    <div class="ad-badge">Sponsored Offer</div>
                    <h2 class="ad-title">{{ service.merchantId.advertisement.title }}</h2>
                    <p class="ad-text">{{ service.merchantId.advertisement.text }}</p>
                </div>
                <div class="ad-code" *ngIf="service.merchantId.advertisement.code">
                    <span>Use Code</span>
                    <strong>{{ service.merchantId.advertisement.code }}</strong>
                </div>
            </section>

            <!-- Quick Highlights -->
            <section class="quick-highlights">
                <div class="highlight-chip">
                    <span class="material-symbols-outlined">sell</span>
                    <div class="chip-text">
                        <small>Starting from</small>
                        <strong>₹ {{service.price}}</strong>
                    </div>
                </div>
                <div class="highlight-chip">
                    <span class="material-symbols-outlined">schedule</span>
                    <div class="chip-text">
                        <small>Duration</small>
                        <strong>{{service.duration || 'Not specified'}}</strong>
                    </div>
                </div>
                <div class="highlight-chip">
                    <span class="material-symbols-outlined">map</span>
                    <div class="chip-text">
                        <small>Cities Served</small>
                        <strong>{{service.service_locations?.length || 1}} Cities</strong>
                    </div>
                </div>
                <div class="highlight-chip">
                    <span class="material-symbols-outlined">payments</span>
                    <div class="chip-text">
                        <small>Payment</small>
                        <strong>{{service.payment?.type === 'ADVANCE' ? 'Advance Required' : 'Full Payment'}}</strong>
                    </div>
                </div>
            </section>

            <!-- About Service -->
            <section class="content-section">
                <h2>About this Service</h2>
                <div class="description-box" [class.expanded]="isDescriptionExpanded">
                    <p>{{service.description || 'No description provided by the vendor yet.'}}</p>
                </div>
                <button class="read-more-btn" (click)="toggleDescription()" *ngIf="service.description && service.description.length > 200">
                    {{ isDescriptionExpanded ? 'Read Less' : 'Read More' }}
                    <span class="material-symbols-outlined">{{ isDescriptionExpanded ? 'expand_less' : 'expand_more' }}</span>
                </button>
            </section>

            <!-- What's Included -->
            <section class="content-section" *ngIf="service.included?.length">
                <h2>What's Included</h2>
                <div class="included-grid">
                    <div class="included-item" *ngFor="let item of service.included">
                        <span class="material-symbols-outlined check-icon">check_circle</span>
                        <span>{{item}}</span>
                    </div>
                </div>
            </section>

            <!-- Portfolio Gallery (Masonry) -->
            <section class="content-section" *ngIf="imageList.length > 0">
                <div class="section-header">
                    <h2>Portfolio</h2>
                    <div class="filter-pills">
                        <button *ngFor="let filter of galleryFilters" 
                                [class.active]="activeGalleryFilter === filter"
                                (click)="setGalleryFilter(filter)">
                            {{filter}}
                        </button>
                    </div>
                </div>
                
                <div class="masonry-grid">
                    <div class="masonry-item" *ngFor="let img of filteredPortfolio | slice:0:4; let i = index; let isLast = last" 
                         (click)="openImage(img)" 
                         [class.overlay]="isLast && filteredPortfolio.length > 4">
                        <img [src]="imageUrl + img.media_url" alt="Portfolio Image">
                        <div class="hover-zoom" *ngIf="!(isLast && filteredPortfolio.length > 4)">
                            <span class="material-symbols-outlined">zoom_in</span>
                        </div>
                        <div class="more-photos-overlay" *ngIf="isLast && filteredPortfolio.length > 4">
                            <span class="material-symbols-outlined">grid_view</span>
                            <span>+{{ filteredPortfolio.length - 4 }} Photos</span>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Videos -->
            <ng-container *ngIf="service.media">
                <section class="content-section" *ngIf="videoList.length > 0">
                    <h2>Videos & Reels</h2>
                    <div class="video-carousel">
                        <ng-container *ngFor="let video of videoList">
                            <div class="video-card">
                                <video [src]="imageUrl + video.media_url" controls preload="metadata"></video>
                            </div>
                        </ng-container>
                    </div>
                </section>
            </ng-container>

            <!-- Customer Reviews -->
            <section class="content-section">
                <div class="section-header">
                    <h2>Customer Reviews</h2>
                    <div class="rating-summary">
                        <span class="material-symbols-outlined icon-star large">star</span>
                        <span class="score">{{mockVendor.rating}}</span>
                        <span class="count">({{mockVendor.reviewCount}} Reviews)</span>
                    </div>
                </div>
                
                <div class="reviews-grid">
                    <div class="review-card" *ngFor="let review of mockReviews">
                        <div class="review-header">
                            <img [src]="review.avatar" alt="Avatar" class="avatar">
                            <div class="reviewer-info">
                                <h4>{{review.name}}</h4>
                                <span class="date">{{review.date}}</span>
                            </div>
                            <div class="stars">
                                <span class="material-symbols-outlined icon-star" *ngFor="let i of [1,2,3,4,5]" [class.filled]="i <= review.rating">star</span>
                            </div>
                        </div>
                        <p class="review-text">{{review.text}}</p>
                    </div>
                </div>
                <button class="btn-outline-primary mt-3">Show All {{mockVendor.reviewCount}} Reviews</button>
            </section>

            <!-- Similar Vendors -->
            <!-- Similar Vendors -->
<section class="content-section" *ngIf="similarVendors.length > 0">

    <div class="section-header">
        <h2>Similar Vendors</h2>
    </div>

    <div class="horizontal-scroll">

        <div
            class="similar-card"
            *ngFor="let vendor of similarVendors"
            (click)="openVendor(vendor)"
        >

            <!-- Vendor Image -->
            <div class="similar-vendor-image">

                <img
                    [src]="getVendorImage(vendor)"
                    [alt]="vendor.business_name"
                    
                >

                <!-- Premium Badge -->
                <span
                    class="vendor-premium-badge"
                    *ngIf="vendor.subscriptionTier === 'PREMIUM'"
                >
                    <span class="material-symbols-outlined">
                        workspace_premium
                    </span>
                    Premium
                </span>

            </div>

            <!-- Vendor Details -->
            <div class="card-content">

                <h4>
                    {{vendor.business_name}}
                </h4>

                <!-- Rating -->
                <div class="row-meta">

                    <span
                        class="rating"
                        *ngIf="vendor.rating"
                    >
                        <span class="material-symbols-outlined icon-star">
                            star
                        </span>

                        {{vendor.rating}}

                        <span
                            class="review-count"
                            *ngIf="vendor.totalReviews"
                        >
                            ({{vendor.totalReviews}})
                        </span>
                    </span>

                    <span
                        class="verified-label"
                        *ngIf="vendor.status === 'APPROVED'"
                    >
                        <span class="material-symbols-outlined">
                            verified
                        </span>
                        Verified
                    </span>

                </div>

                <!-- Location -->
                <div
                    class="vendor-location"
                    *ngIf="vendor.city || vendor.district"
                >

                    <span class="material-symbols-outlined">
                        location_on
                    </span>

                    <span>
                        {{vendor.city || vendor.district}}
                    </span>

                </div>

            </div>

        </div>

    </div>

</section>
            
        </div>

        <!-- Right Sidebar (Sticky Booking Card) -->
        <div class="right-column">
            <div class="sticky-booking-card">
                <div class="price-header">
                    <span class="price">₹ {{service.price}}</span>
                    <span class="price-label">Starting Price</span>
                </div>
                
                <div class="booking-meta">
                    <div class="meta-row">
                        <span class="material-symbols-outlined">schedule</span>
                        <span>{{service.duration || 'Flexible Duration'}}</span>
                    </div>
                    <div class="meta-row" *ngIf="service.payment?.type === 'ADVANCE'">
                        <span class="material-symbols-outlined">payments</span>
                        <span>₹ {{service.payment?.advanceAmount}} Advance Required</span>
                    </div>
                </div>
                
                <div class="action-buttons">
                    <button class="btn-primary-large" (click)="openBookingCalendar()">
                        Book Now
                    </button>
                    <button class="btn-secondary-large" (click)="openEnquiry()">
                        Send Enquiry
                    </button>
                </div>
                
                <div class="utility-actions">
                    <button class="util-btn"><span class="material-symbols-outlined">favorite_border</span> Save</button>
                    <button class="util-btn"><span class="material-symbols-outlined">share</span> Share</button>
                    <button class="util-btn"><span class="material-symbols-outlined">flag</span> Report</button>
                </div>
                
                <div class="guarantee-box">
                    <span class="material-symbols-outlined">verified_user</span>
                    <div>
                        <strong>Weddingly Guarantee</strong>
                        <p>100% secure payments and verified vendors.</p>
                    </div>
                </div>
            </div>
        </div>
        
    </div>

</div>

<!-- Fixed Bottom Bar (Mobile Only) -->
<div class="mobile-bottom-bar" *ngIf="service">
    <div class="price-col">
        <span class="label">Starting Price</span>
        <span class="price">₹ {{service.price}}</span>
    </div>
    <div class="action-col">
        <button class="btn-primary" (click)="openBookingCalendar()">Book</button>
        <button class="btn-icon" (click)="openEnquiry()"><span class="material-symbols-outlined">chat</span></button>
    </div>
</div>

<!-- Fullscreen Lightbox Viewer -->
<div class="fullscreen-viewer" *ngIf="showViewer">
    <div class="viewer-header">
        <div class="counter">{{selectedIndex + 1}} / {{imageList.length}}</div>
        <button class="close-btn" (click)="closeViewer()">
            <span class="material-symbols-outlined">close</span>
        </button>
    </div>

    <button class="nav-btn prev" (click)="previousImage()" *ngIf="selectedIndex > 0">
        <span class="material-symbols-outlined">chevron_left</span>
    </button>
    
    <div class="viewer-content">
        <img [src]="imageUrl + imageList[selectedIndex]?.media_url" alt="Fullscreen Image">
    </div>

    <button class="nav-btn next" (click)="nextImage()" *ngIf="selectedIndex < imageList.length - 1">
        <span class="material-symbols-outlined">chevron_right</span>
    </button>
    
    <!-- Lightbox Thumbnails -->
    <div class="viewer-thumbnails">
        <div class="thumb-track">
            <div class="thumb" *ngFor="let img of imageList; let i = index" 
                 [class.active]="i === selectedIndex"
                 (click)="selectedIndex = i">
                <img [src]="imageUrl + img.media_url" alt="Thumbnail">
            </div>
        </div>
    </div>
</div>